type SearchDedupeState = {
  query: string;
  timestamp: number;
};

const SEARCH_DEDUPE_QUERY_KEY = "telemetry_search_last_query";
const SEARCH_DEDUPE_TIMESTAMP_KEY = "telemetry_search_last_timestamp";

let fallbackSearchDedupe: SearchDedupeState | null = null;

export function shouldSample(rate: number): boolean {
  if (!Number.isFinite(rate)) {
    return true;
  }
  if (rate >= 1) {
    return true;
  }
  if (rate <= 0) {
    return false;
  }
  return Math.random() < rate;
}

function readSearchDedupeState(): SearchDedupeState | null {
  if (typeof window === "undefined") {
    return fallbackSearchDedupe;
  }

  try {
    const query = window.sessionStorage.getItem(SEARCH_DEDUPE_QUERY_KEY);
    const timestampRaw = window.sessionStorage.getItem(SEARCH_DEDUPE_TIMESTAMP_KEY);
    const timestamp = timestampRaw ? Number(timestampRaw) : null;
    if (!query || !timestamp || !Number.isFinite(timestamp)) {
      return null;
    }
    return { query, timestamp };
  } catch (error) {
    console.debug("[telemetry] Unable to read search dedupe state:", error);
    return fallbackSearchDedupe;
  }
}

function writeSearchDedupeState(state: SearchDedupeState) {
  if (typeof window === "undefined") {
    fallbackSearchDedupe = state;
    return;
  }

  try {
    window.sessionStorage.setItem(SEARCH_DEDUPE_QUERY_KEY, state.query);
    window.sessionStorage.setItem(SEARCH_DEDUPE_TIMESTAMP_KEY, state.timestamp.toString());
  } catch (error) {
    console.debug("[telemetry] Unable to write search dedupe state:", error);
    fallbackSearchDedupe = state;
  }
}

export function shouldDedupeSearchEvent(query: string, windowMs: number): boolean {
  if (!query || windowMs <= 0 || !Number.isFinite(windowMs)) {
    return false;
  }

  const now = Date.now();
  const last = readSearchDedupeState();

  if (last && last.query === query && now - last.timestamp < windowMs) {
    return true;
  }

  writeSearchDedupeState({ query, timestamp: now });
  return false;
}
